import { PayoutChannel } from 'generated';
import { TranslateFn } from 'i18n';

interface SelectedPayoutProps {
  payout?: PayoutChannel;
  t: TranslateFn;
}

const SelectedPayout = ({ payout, t }: SelectedPayoutProps) => {
  if (!payout) return null;

  return (
    <ul
      style={{
        listStyleType: 'disc',
        margin: '1rem auto',
        width: 'fit-content',
      }}
    >
      <li>
        {t('product_details.prices.payoutFrequency', 'Frequency')}
        {': '}
        <span style={{ fontWeight: 700 }}>
          {payout.frequencyIndividual
            ? t('product_details.payoutFrequency.individual', 'Individual')
            : t(`product_details.payoutFrequency.${payout.frequencyNameKey}`, payout.frequencyName)}
        </span>
      </li>
      <li>
        {t('product_details.prices.payoutChannel', 'Payout channel')}
        {': '}
        <span style={{ fontWeight: 700 }}>
          {t(`product_details.payouts.*.${payout.nameKey}.name`, payout.name)}
        </span>
      </li>
    </ul>
  );
};

export default SelectedPayout;
